import { Injectable, Input, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { IIntervallo } from './../../model/ambulatorio';


@Injectable()
export class ClinicStyle implements OnDestroy {

	protected readonly nextMap: (map: Map<string, number>) => void;
	protected readonly sheet: CSSStyleSheet;
	private readonly htmlReference: JQuery<HTMLElement>;

	public readonly mappings: Observable<Map<string, number>>;

	constructor() {
		this.htmlReference = $("<style>").appendTo("head");
		this.sheet = this.htmlReference.prop("sheet") as CSSStyleSheet;
		const mappings = new Subject<Map<string, number>>();
		this.mappings = mappings.asObservable();
		this.nextMap = (map: Map<string, number>) => mappings.next(map);
	}

	protected clear() {
		while (this.sheet.cssRules.length) {
			this.sheet.deleteRule(this.sheet.cssRules.length - 1);
		}
	}

	ngOnDestroy(): void {
		this.clear();
		this.htmlReference.remove();
	}


	@Input()
	set days(days: IIntervallo[][] | false) {
		const mapping = new Map<string, number>();
		if (days) {
			for (const slots of days) {
				for (const slot of slots) {
					let name = "-name";
					let content = "";
					if (!slot.ambulatorio) {
						name = "";
					} else {
						content = JSON.stringify(slot.ambulatorio);
					}
					const ambulatorio = slot.ambulatorio ? slot.ambulatorio.toLowerCase() : " ";
					if (!mapping.has(ambulatorio)) {
						// Imposto la regola.
						if (this.sheet.cssRules.length == mapping.size) {
							this.sheet.insertRule(`
									.fc-bgevent.clinic-style${name}-${mapping.size}::after {
										display: block;
										-webkit-transform: rotate(-90deg);
										transform: rotate(-90deg);
										-webkit-transform-origin: right top;
										transform-origin: right top;
										border-radius: 0px 0px 5px 5px;
										border: 1px blue solid;
										color: blue;
										float: right;
										font-size: 0.7em;
										text-transform: uppercase;
										padding: 0px 5px;
										border-top: 0;
										font-weight: bold;
									}`,
								this.sheet.cssRules.length
							);
						}

						const rule = this.sheet.cssRules.item(mapping.size) as CSSStyleRule;
						rule.style.content = content;

						// Quindi imposto l'id di traduzione
						mapping.set(ambulatorio, mapping.size);
					}

				}
			}
		}

		this.nextMap(mapping);
	}
}



// WEBPACK FOOTER //
// ./src/app/calendar/clinic-style/clinic-style.component.ts